import React, { forwardRef, useEffect, useRef, HTMLAttributes } from "react";
import classNames from "classnames";

import { generateId } from "./generateId";
import { useBottomSheetContext } from "./bottomSheetContext";

export type TitleProps = HTMLAttributes<HTMLHeadingElement>;

export const Title = forwardRef<HTMLHeadingElement, TitleProps>(
  ({ className, children, id: idProp, ...rest }, ref) => {
    const { setTitleId } = useBottomSheetContext();
    const generatedIdRef = useRef(generateId("ui-bottom-sheet-dialog-title-"));
    const id = idProp || generatedIdRef.current;

    useEffect(() => {
      setTitleId(id);
      return () => setTitleId(undefined);
    }, [id, setTitleId]);

    return (
      <h2 {...rest} ref={ref} id={id} className={classNames("ui-bottom-sheet-dialog-title", className)}>
        {children}
      </h2>
    );
  },
);

Title.displayName = "BottomSheet.Title";
